export default __webpack_public_path__ + "static/media/empty-collection.a40f3fe2.webp";